import { useMutation } from "@tanstack/react-query";
import {
  type SendDirectPaymentResponse,
  postTransactionsDirectPay,
  type ErrorResponse,
  type SendDirectPaymentRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { isIOS } from "Utils/Platform/PlatformUtils";

// shouldReturnToNativeApp is decided here (via isIOS()), not by callers — same rule as
// useTransactionPay, so a direct payment signed in the iOS shell bounces back into the app.
export type DirectPaymentVariables = Omit<
  SendDirectPaymentRequest,
  "shouldReturnToNativeApp"
>;

type Props = {
  onSuccess?: (
    data: SendDirectPaymentResponse,
    variables: DirectPaymentVariables,
  ) => void;
  onError?: (error: ErrorResponse, variables: DirectPaymentVariables) => void;
};

export const useDirectPaymentMutation = ({ onSuccess, onError }: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (request: DirectPaymentVariables) =>
        postTransactionsDirectPay({
          ...request,
          // getPlatform() is "ios" only inside the Capacitor shell (not mobile Safari).
          shouldReturnToNativeApp: isIOS(),
        }),
    ),
    onSuccess,
    onError,
  });
